import { handleOnChangeDataFirstCoOwnerRenewal } from './helpers';
import {
  getFirstCoownerData,
  getQuotation,
} from 'app/services/businessFunctionHelpers';
import { checkHasDataChangedForRenewal } from 'app/services/businessFunctions/helpers/checkHasDataChangedForRenewal';
import { setMainOwnerSelectionDictionary } from 'app/shared/helpers/setMainOwnerSelectionDictionary';

const firstCoownerOnFirstCoownerLastNameChange = {
  onFirstCoownerLastNameChange(initialRun?: boolean) {
    const { lastName } = getFirstCoownerData();
    const { coOwners } = getQuotation();

    const previousLastName = coOwners?.[0]?.lastName || '';

    if (checkHasDataChangedForRenewal(lastName, previousLastName)) {
      handleOnChangeDataFirstCoOwnerRenewal(initialRun);
    }

    setMainOwnerSelectionDictionary();
  },
};

export default firstCoownerOnFirstCoownerLastNameChange;
